<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Leave Reports</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label for="fyName" class="col-form-label col-sm-3">Financial Year
            <span class="text-danger">*</span></label>
          <div class="col-sm-6">
            <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedFy">
              <option value="">Select Financial Year
              </option>
              <option *ngFor="let fy of financialYearList" [ngValue]="fy">{{fy.name}}</option>

            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <label for="" class="col-sm-3">Roles <span class="text-danger form-label ">*</span></label>
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width:100%;">
              <!-- <mat-label>Clients :</mat-label> -->
              <mat-select multiple (selectionChange)='getRoleAndBranch()' [(ngModel)]="selectedRole"
                #designateRole="ngModel">
                <mat-option (click)="selectAllRole(designateRole,roleList)" [value]="0">Select All</mat-option>
                <mat-option #item *ngFor="let role of roleList" [value]="role.id">
                  {{role.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label for="" class="col-sm-3">Branch Name <span class="text-danger form-label ">*</span></label>
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width:100%;">
              <!-- <mat-label>Clients :</mat-label> -->
              <mat-select multiple (selectionChange)='getRoleAndBranch()' [(ngModel)]="selectedBranch"
                #designateBranch="ngModel">
                <mat-option (click)="selectAllBranch(designateBranch,branchList)" [value]="0">Select All</mat-option>
                <mat-option #item *ngFor="let branch of branchList" [value]="branch.id">
                  {{branch.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <label for="" class="col-sm-3">Employee name <span class="text-danger form-label ">*</span></label>
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width:100%;">
              <!-- <mat-label>Clients :</mat-label> -->
              <mat-select multiple [(ngModel)]="selectedEmp" #designateEmp="ngModel">
                <mat-option (click)="selectAllEmp(designateEmp,empList)" [value]="0">Select All</mat-option>
                <mat-option #item *ngFor="let emp of empList" [value]="emp">
                  {{emp.firstName}} {{emp.middleName}} {{emp.lastName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-2">
        <button id="saveFyBtn" name="saveFyBtn" type="button" class="btn btn-sm btn-block btn-outline-theme"
          (click)="onViewReport()">View Report</button>
      </div>

      <div class="col-sm-2" *ngIf="showExportToExcelButton">
        <button
          (click)="exportToExcelClick()"
          class="btn btn-sm btn-block btn-outline-theme"
        >
          <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
        </button>
      </div>
    </div>


    <!-- </form> -->
  </div>
</div>

<div class="container" id="mainContent">
  <div class="container" *ngIf="reportOutput != null">
    <div class="row pt-3 justify-content-center text-center">
      <span class="bg-theme-title"
        >P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>
    <div class="row pt-3">
      <div class="col-sm-6"><label>Name Of the Employee : </label><label>{{reportOutput.firstName}}
        {{reportOutput.middleName}} {{reportOutput.lastName}}</label></div>
    </div>
    <div class="row">
      <div class="col-sm-6"><label>Date Of Joining : </label><label>{{reportOutput.joiningDate | date : 'dd-MMM-yyyy'}}
        </label></div>
      <div class="col-sm-6"><label>Branch : </label><label>{{reportOutput.branch}} </label></div>
    </div>
    <div class="row">
      <div class="col-sm-12"><label>Details of Leaves Balance Calculation for period : </label><label>
          {{selectedFy.name}} </label></div>

    </div>
    <div class="row">
      <div class="col-sm-6">
        <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="selectedEmp.length" [maxSize]="5"
          (pageChange)="loadPage($event)"></ngb-pagination>
      </div>
    </div>  

    <div class="row col-md-12">
      <div class="table-responsive cnstr-record ">
        <table class="table table-bordered heading-hvr">
          <tr>
            <th>Month</th>
            <th>Opening Balance</th>
            <th>Leaves Taken</th>
            <th>Closing Balance</th>
            <th>Leave Type</th>
            <th>Leave Dates</th>

          </tr>
          <tbody>
            <ng-container *ngFor="let leave of reportOutput.leaveDetails;">
              
              <ng-container *ngFor="let detail of leave.leaveTypeAndDate;let detailIndex = index;
                let detailCount = count;">
                <tr *ngIf="detailIndex==0">
                  <td [attr.rowspan]="detailCount">{{leave.month}}</td>
                  <td [attr.rowspan]="detailCount">{{leave.openingBalance}}</td>
                  <td [attr.rowspan]="detailCount">{{leave.leaves}}</td>
                  <td [attr.rowspan]="detailCount">{{leave.closingBalance}}</td>
                  <td>{{leave.leaveTypeAndDate==null?"":detail.name}}</td>
                  <td>{{leave.leaveTypeAndDate==null?"":detail.fromDate | date : 'dd-MMM-yyyy'}}</td>

                </tr>
                <tr *ngIf="detailIndex!=0">
                  <td>{{leave.leaveTypeAndDate==null?"":detail.name}}</td>
                  <td>{{leave.leaveTypeAndDate==null?"":detail.fromDate | date : 'dd-MMM-yyyy'}}</td>
                </tr>

              </ng-container>
            </ng-container>
            <tr *ngIf="reportOutput.leaveDetails== null">
              <td style="text-align: center;" colspan="6">No Entries available</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</div>